import { useTranslation } from 'react-i18next';
import {
  Action,
  ActionsTableMenu,
} from 'src/components/atoms/actions-table-menu';
import { usePermissions } from 'src/permissions/can';

interface Props {
  onRemove: () => void;
}

export function EmployeesGroupDetailsSpaceGroupsActionsTableMenu({
  onRemove,
}: Props) {
  const { t } = useTranslation(['employeesGroups', 'common']);

  const permissions = usePermissions();

  const actions: Action[] = [
    {
      id: 'remove',
      label: t('employeesGroups:spaceGroups.remove'),
      onClick: onRemove,
      disabled: permissions.cannot('delete', 'EmployeesGroupSpaceGroups'),
      tooltip: t('common:notSufficientPermissions'),
    },
  ];

  return <ActionsTableMenu actions={actions} />;
}
